import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';
import { ProcessService } from 'src/app/services/process.service';
// import { $ } from 'protractor';

declare var $: any;
@Component({
  selector: 'smart-plot',
  templateUrl: './plot.component.html',
  styleUrls: ['./plot.component.css']
})
export class PlotComponent implements OnInit {
  constructor(
  ) { }
  ngOnInit() {
  }
}
